<template>

</template>

<script>
export default {
  name: "yieldDetailTabsThree"
}
</script>

<style scoped>

</style>
